/**
 * Relógio reativo para checagem da janela PA (atualiza a cada minuto e ao focar a aba).
 */
import { useEffect, useState } from "react";
import dayjs, { type Dayjs } from "dayjs";

export function useProntoAtendimentoNow(intervalMs = 60_000): Dayjs {
  const [now, setNow] = useState(() => dayjs());

  useEffect(() => {
    const tick = () => setNow(dayjs());
    const id = window.setInterval(tick, intervalMs);
    window.addEventListener("focus", tick);
    return () => {
      window.clearInterval(id);
      window.removeEventListener("focus", tick);
    };
  }, [intervalMs]);

  return now;
}
